<!--//@*/*
    //    *BCS   App v0.91
    //    * Copyright (c) 2025, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

<template>
  <v-container>
    <brandbar></brandbar>

    <v-container id="nibrs_review_waiver" class="mt-13">
      <!-- header -->
      <div class="header d-flex flex-column align-center">
        <p class="mb-0">RENO POLICE DEPARTMENT</p>
        <p class="mb-0">EXECUTIVE DIRECTIVE</p>
        <p class="mb-0">NIBRS REVIEW ACKNOWLEDGEMENT</p>
      </div>

      <hr />

      <!-- FORM -->
      <nibrs_review_form></nibrs_review_form>

      <v-row class="d-flex flex-column justify-start mt-0">
        <v-col>
          <p class="sub-header">
            A copy of this record will be placed in the employee's personnel
            file; such placement does not affect the validity of the record.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .header p {
    font-size: 1.2em;
    font-weight: 400;
  }

  .sub-header p,
  .sub-header ol {
    font-size: 1em;
    font-weight: 300;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import brandbar from "./brandbar.vue";
import nibrs_review_form from "./nibrs_review_form.vue";

export default {
  name: "home",
  components: { nibrs_review_form, brandbar },
  mixins: [bus_common],

  // DATA - return
  data() {
    return {
      /* report header info */
      formIn: {},
    };
  },

  //COMPUTED
  computed: {},
  // WATCH
  watch: {},

  //METHODS

  methods: {
    message1() {
      alert("This button will submit the form");
    },
    message2() {
      alert("This button will cancel the form");
    },
  },

  // newRandA

  // INIT
  init() {},

  // mounted
  mounted() {
    this.$nextTick(() => {
      // this.init();
    });
  },
};
</script>
